import TopMenu from '../../../Components/TopMenu/TopMenu';
import React, { useState, useEffect, useRef, useMemo } from 'react';
import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row, Table, Dropdown, Modal, Tab, Tabs, Stack, Button, Form, Accordion } from 'react-bootstrap';
import { faPlus, faXmark, faPencil, faPaperclip, faCalendarDays, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear, faCog, faTimes, faUser } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';
import Arcv from "../../../assets/images/archive.svg";
import Activ from "../../../assets/images/active.svg";
import edit from "../../../assets/images/edit.png";
import details from "../../../assets/images/Details.png";
import View from "../../../assets/images/view.png";
import Trash from "../../../assets/images/trash.png";
import Edit from "../../../assets/images/edit.png";
import flight_img from '../../../assets/images/flight_removebg_preview.png'; 
import EmailGreen from "../../../assets/images/recover_email.png";
import EmailRed from "../../../assets/images/pending_email.png";    
import trash from "../../../assets/images/trash.png";
// import view from "../../../assets/images/view.png";
import Select from 'react-select';
import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { GETULDDETAILS, MOVETOACTARC, RECOVERYARCACT, RECOVERYDETAILS, GETDESTINATION } from '../../../Utils/conts.js';
import { toast } from 'react-toastify';
import Rapdf from "../../../assets/images/pdf.png";
import Customer from '../../Settings/FSM/CustomerSettings';
import { jqxCookieCall } from '../../../Components/common/CommonFunctions.js';
const Quotation = () => {

    const [packageShow, setPackageShow] = useState(true);
    const history = useHistory();
    const [emailId, setEmailId] = useState();
    const [isDLoading,setDLoading] = useState(false)
    const [emailData , setEmailData] = useState();
    const [showModal, setShowModal] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [confirmationInfo, setConfirmationInfo] = useState('');
    const [deleteId, setDeleteId] = useState('');
    const [savedPackages, setSavedPackages] = useState([]);
    const [packageGroups, setPackageGroups] = useState([
        { number_of_packages: '', length: '', width: '', height: '', gross_weight: "",volumetric_weight: '',chargeable_weight: '', total_freight_cost: '' }
      ]);
    const [editIndex, setEditIndex] = useState(null);
    const [rp_kg,setRp_kg] = useState();
    const [divisor,setDivisor] = useState();
    const [activeTab, setActiveTab] = useState('Active');
    const gridRefs = {
        Active: useRef(null),
        Archived: useRef(null),
    }

    const handleTabChange = async (tab) => {
    setActiveTab(tab);
    // const tabType = () => {tab == 'Active' ? 'A' : 'R'}
    setFilterApplied(false);
    if (selectedRowData) {
      setSelectedRowData(null)
    }
    setGridSelect([]);
    setIsLoading(true);
    if (tab == 'Active') {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Active: {} });
      }, 1);
    } else {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Archived: {} });
      }, 1);
    }
  }

    const fetchSettings = async () => {
        try {
            const res = await withRFSToken.get('general-setting/get-setting');
            const innerData = res?.data?.response_data?.settings;
            // console.log("innerData",innerData)
            setRp_kg(parseFloat(innerData.rate));
            setDivisor(parseFloat(innerData.divisor))
        } catch (error) {
            console.error('Error fetching settings:', error);
            toast.error('Failed to load settings');
        }
    };

    const calculatePackageMetrics = (group) => {
        const length = parseFloat(group.length) || 0;
        const width = parseFloat(group.width) || 0;
        const height = parseFloat(group.height) || 0;
        const qty = parseFloat(group.number_of_packages) || 0;
        const grossWeight = parseFloat(group.gross_weight) || 0;

        // Volumetric Weight (kg) = (Qty * L * W * H) / divisor
        const divisorValue = Number(divisor) || 6000;
        const volumetricWeight = (length * width * height * qty) / divisorValue;

        const chargeableWeight = Math.max((grossWeight * qty), volumetricWeight);

        const totalFreightCost = chargeableWeight * (rp_kg || 0);

        return {
            volumetric_weight: volumetricWeight ? volumetricWeight.toFixed(2) : '',
            chargeable_weight: chargeableWeight ? chargeableWeight.toFixed(2) : '',
            total_freight_cost: totalFreightCost ? totalFreightCost.toFixed(2) : ''
        };
    };

    // Calculate totals for all saved packages
    const calculateTotalPackages = (packagesArray) => {
        return packagesArray.reduce((total, pkg) => total + (parseInt(pkg.number_of_packages) || 0), 0);
    };

    const calculateTotalWeight = (packagesArray) => {
        return packagesArray.reduce((total, pkg) => total + (parseFloat(pkg.gross_weight) || 0), 0);
    };

    // Helper: safely parse numeric strings to numbers
    const parseNumber = (value) => {
        const num = Number(value);
        return Number.isFinite(num) ? num : 0;
    };

    // Totals computed from savedPackages
    const totals = useMemo(() => {
        let totalVolumetric = 0;
        let totalChargeable = 0;
        if (Array.isArray(savedPackages)) {
            savedPackages.forEach((pkg) => {
                const metrics = calculatePackageMetrics(pkg);
                totalVolumetric += Number(metrics.volumetric_weight) || 0;
                totalChargeable += Number(metrics.chargeable_weight) || 0;
            });
        }
        return {
            totalVolumetricWeight: totalVolumetric ? totalVolumetric.toFixed(2) : '0.00',
            totalChargeableWeight: totalChargeable ? totalChargeable.toFixed(2) : '0.00',
        };
    }, [savedPackages, divisor, rp_kg]);

    const handleAddGroup = () => {
        setPackageGroups([...packageGroups, { number_of_packages: '', length: '', width: '', height: '', gross_weight: '', volumetric_weight: '', chargeable_weight: '', total_freight_cost: '' }]);
    };

    const handleDeleteGroup = (index) => {
        if (packageGroups.length > 1) {
            const updatedGroups = packageGroups.filter((_, idx) => idx !== index);
            setPackageGroups(updatedGroups);
        }
    };

    const handleGroupChange = (index, field, value) => {
        const updatedGroups = [...packageGroups];
        updatedGroups[index][field] = value;

        // Auto-calculate metrics when length, width, height, number_of_packages, or gross_weight changes
        if (['length', 'width', 'height', 'number_of_packages', 'gross_weight'].includes(field)) {
            const metrics = calculatePackageMetrics(updatedGroups[index]);
            updatedGroups[index].volumetric_weight = metrics.volumetric_weight;
            updatedGroups[index].chargeable_weight = metrics.chargeable_weight;
            updatedGroups[index].total_freight_cost = metrics.total_freight_cost;
        }

        setPackageGroups(updatedGroups);
    };

    const handleEditHawb = (idx) => {
        const packageToEdit = savedPackages[idx];
        setPackageGroups([{ ...packageToEdit }]);
        setEditIndex(idx);
        setPackageShow(true);
    };
    const handleSaveHawb = () => {
        // Validate required fields for all groups
        for (let i = 0; i < packageGroups.length; i++) {
            const group = packageGroups[i];
            if (!group.number_of_packages || !group.length || !group.height) {
                toast.error(`Group ${i + 1}: Number of packages, Length, and Height are required!`);
                return;
            }
        }

        let updatedPackages;
        if (editIndex !== null) {
            // Update existing package - for now, we'll replace with all current groups
            updatedPackages = savedPackages.map((item, idx) => 
                idx === editIndex ? { ...packageGroups[0] } : item
            );
        } else {
            // Add new packages for each group
            updatedPackages = [...savedPackages, ...packageGroups];
        }

        setSavedPackages(updatedPackages);
        
        // Reset form
        setPackageGroups([{ number_of_packages: '', length: '', width: '', height: '', gross_weight: '', volumetric_weight: '', chargeable_weight: '', total_freight_cost: '' }]);
        setEditIndex(null);
        setPackageShow(false);
        
        toast.success(editIndex !== null ? "Package updated successfully!" : "Packages added successfully!");
    };
    const handleDeleteHawb = (idx) => {
        const updatedPackages = savedPackages.filter((_, i) => i !== idx);
        setSavedPackages(updatedPackages);
        
        // If we're editing the deleted package, reset the form
        if (editIndex === idx) {
            setPackageGroups([{ number_of_packages: '', length: '', width: '', height: '', gross_weight: '', volumetric_weight: '', chargeable_weight: '', total_freight_cost: '' }]);
            setEditIndex(null);
        }
        
        toast.success("Package deleted successfully!");
    };

    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [gridData, setGridData] = useState({});
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const [disLoading, setDisLoading] = useState(false);
    const [filterApplied, setFilterApplied] = useState(false);
    const [quotation, setQuotation] = useState([]);
    const [quotationModal, setQuotationModal] = useState(false);
    // const [formData, setFormData] = useState({assign_to:'61'});
    const initialFormData = { assign_to: '61' };
    const [formData, setFormData] = useState({customer_type : 'C'});
    
    // Customer-related state variables
    const [contactModal, setContactModal] = useState(false);
    const [customerModal, setCustomerModal] = useState(false);
    const [customerData, setCustomerData] = useState({});
    const cgridRef = useRef(null);
    const [cgridData, setCgridData] = useState([]);
    const [isLoadingc, setIsLoadingc] = useState(true);
    const [customerGridSelect, setCustomerGridSelect] = useState([]);
    const defaultRow = {
        origin: '',
        destination: '',
        no_of_package: '',
        length: '',
        width: '',
        height: '',
        gross_weight: '',
        volumetric_weight: 0,
        chargeable_weight: 0,
        total_freight_cost: 0,
    };
     const incotermOption = [
        // { label: '--', value: '' },
        { label: 'EXW - Ex Works', value: 'EXW' },
        { label: 'FCA - Free Carrier', value: 'FCA' },
        { label: 'FAS - Free Alongside Ship', value: 'FAS' },
        { label: 'FOB - Free On Board', value: 'FOB' },
        { label: 'CPT - Carriage Paid To', value: 'CPT' },
        { label: 'CIP - Carriage and Insurance Paid', value: 'CIP' },
        { label: 'CFR - Cost and Freight', value: 'CFR' },
        { label: 'CIF - Cost Insurance and Freight', value: 'CIF' },
        { label: 'DAP - Delivered At Place', value: 'DAP' },
        { label: 'DPU - Delivered At Place Unloaded', value: 'DPU' },
        { label: 'DDP - Delivered Duty Paid', value: 'DDP' }
    ];
    const [getDestination, setGetDestination] = useState([]);
    const [getCustomer, setGetCustomer] = useState([]);
    const fetchDestination = async () => {
        try {
            const res = await withRFSToken.post(GETDESTINATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: `${item.port_code} - ${item.station_name}`,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchQuotation = async (id, type) => {
            try {
                const params = { id };
                if (type) params.type = type; // only include type if provided
                const response = await withRFSToken.get("quotation-details", { params });
                //console.log("response", response.data);
                setQuotation(response?.data?.response_data)
            } catch (error) {
                console.error("Error fetching data:", error);
            }
            };
    const fetchCustomer = async (agent_or_customer) => {
        try {
            const res = await withRFSToken.get(`address-book/list?agent_or_customer=${agent_or_customer}`)
                .then(function (res) {
                    const innerData = res.data.Rows;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.id,
                        label: item.name,
                    })) : [];
                    setGetCustomer(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const agentOrCustomer = [
        {label : "Agent" , value: "A"},
        {label: "Customer", value: "C"}
    ]
    const exportOrImport = [
        {label : "Export" , value: "E"},
        {label: "Import", value: "I"}
    ]
    
    const CustomerOptions = [
        { label: 'Airline', value: 'A' },
        { label: 'Forwarder', value: 'F' },
        { label: 'Handler', value: 'H' },
        { label: 'Trucker', value: 'T' }
    ];
    useEffect(() => {
        localStorage.removeItem("SHEdit");
        localStorage.removeItem("id");
        localStorage.removeItem('AddExportInitQuotation');
        if (isMounted.current) return;
        setIsLoading(false);
        fetchDestination();
        fetchCustomer('C');
        setGridData({});
        fetchSettings();
        isMounted.current = true;
    }, []);
    let checkUlds = [];
    let filterForCheck = false;

  useEffect(() => {
        if (gridRefs[activeTab]?.current) {
            // var token = "Bearer " + localStorage.RFS;
            jqxCookieCall()
            const tabType = activeTab === 'Active' ? 'A' : 'R';
            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'export_shipment_record_id', type: 'string' },
                    { name: 'origin', type: 'string' },
                    { name: 'email', type: 'string' },
                    { name: 'destination', type: 'string' },
                    { name: 'number_of_packages', type: 'string' },
                    { name: 'p_length', type: 'string' },
                    { name: 'width', type: 'string' },
                    { name: 'height', type: 'string' },
                    { name: 'gross_weight', type: 'string' },
                    { name: 'job_no', type: 'string' },
                    { name: 'name', type: 'string' },
                    { name: 'incoterm', type: 'string' },
                    { name: 'package_information', type: 'string' },
                    { name: 'status', type: 'string' },
                    { name: 'grand_total_freight_cost', type: 'string' },
                    { name: 'quotation_pdf', type: 'string' },
                    { name: 'created_on', type: 'string' },
                    { name: 'updated_on', type: 'string' },
                    { name: 'updated_by', type: 'string' },
                    { name: 'shipment_type', type: 'string' },
                    { name: 'customer_id', type: 'string' },
                    { name: 'expired_at', type: 'string' },
                ],
                id: `${activeTab}-`,
                url: `${process.env.REACT_APP_RFS_URL}quotation/list?tab=${tabType}`,
                // url: `${process.env.REACT_APP_RFS_URL}quotation/list`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


                    // setTimeout(() => {
                    //     const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

                    //     console.log("rows", rows);
                    //     (checkUlds).forEach(uldNumber => {
                    //         console.log(checkUlds);
                    //         rows.forEach((element, index) => {
                    //             if (element.uld_number == uldNumber) {
                    //                 window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                    //             }
                    //         });
                    //     });
                    // }, 4000);
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            console.log(dataAdapter);
            const columns = [
                {
                text: 'Actions',
                cellsrenderer: function () {
                    return '<div class="grid_actions"><img src="' + View + '" class="row_view" /></div>';
                },
                width: '3%', filterable: false,
                },
                { text: 'Update On',filtertype: 'range', filtermode: 'range', cellsformat: 'dd-MM-yyyy', datafield: 'created_on', width: '8%', cellclassname: '', },
                // {
                //     text: 'Record Action', width: '7%', filtertype: 'textbox',
                //     cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                //         if (rowdata.status === 'Accepted') {
                //             return '<div class="grid_actions"><img src="' + details + '" class="row_view" /></div>';
                //         }
                //         return '<div> </div>';
                //     },
                //     cellclassname: '',
                // },
                {
                    text: 'Customer/Agent Name', filtertype: 'textbox', datafield: 'name', width: '15%', cellclassname: '',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        let emailIcon = '';
                        if (!rowdata.email || rowdata.email === 0) {
                            emailIcon = '<img src="' + EmailRed + '" class="row_email row_email_red" />';
                        } else {
                            emailIcon = '<img src="' + EmailGreen + '" class="row_email row_email_green" />';
                        }
                        return '<div class="jqx-grid-cell-left-align" style="margin-top: 10px;">' + emailIcon + ' ' + value + '</div>';
                    }
                },


                 {
                    text: 'Status', filtertype: 'checkedlist',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        console.log(rowdata);
                        if (rowdata.status === 'Processing') {
                            return '<div class="fw_progess"> ' + value + ' </div>';
                        } else if (rowdata.status === 'Quoted') {
                            return '<div class="fw_complet">' + value + '</div>';
                        } else if (rowdata.status === 'Revised') {
                            return '<div class="fw_progess">' + value + ' </div>';
                        } else if (rowdata.status === 'Rejected') {
                            return '<div class="fw_reserve">' + value + ' </div>';
                        } else if (rowdata.status === 'Accepted') {
                            return '<div class="fw_planed">' + value + ' </div>';
                        } else {
                            return '<div class="fw_onstock">' + value + ' </div>';
                        }
                    },
                    filteritems: [
                        { label: 'New', value: 'new' },
                        { label: 'Processing', value: 'processing' },
                        { label: 'Accepted', value: 'accepted' },
                        { label: 'Rejected', value: 'rejected' },
                        { label: 'Revised', value: 'revised' },
                        { label: 'Quoted', value: 'quoted' },
                    ],

                    datafield: 'status', width: '10%', cellclassname: '',
                },
                { text: 'Origin', filtertype: 'textbox', datafield: 'origin', width: '6%', cellclassname: '', },
                { text: 'Destination', filtertype: 'textbox', datafield: 'destination', width: '6%', cellclassname: '', },
                // { text: 'Number of packages', filtertype: 'textbox', datafield: 'number_of_packages', width: '6%', cellclassname: '', },
                // { text: 'Customer Name', filtertype: 'textbox', datafield: 'customer_name', width: '10%', cellclassname: '', },
              
                { text: 'Job No', filtertype: 'textbox', datafield: 'job_no', width: '6%', cellclassname: '', },
                { text: 'Incoterm', filtertype: 'textbox', datafield: 'incoterm', width: '6%', cellclassname: '', },
                { text: 'Export/Import', filtertype: 'checkedlist',filteritems: [
                    { label: 'Export', value: 'EXPORT' },
                    { label: 'Import', value: 'IMPORT' },                  
                ], datafield: 'shipment_type', width: '8%', cellclassname: '', },
                
                { text: 'Total Price', filtertype: 'textbox', datafield: 'grand_total_freight_cost', width: '8%', cellclassname: '', },
                { text: 'Created On',filtertype: 'range', filtermode: 'range', cellsformat: 'dd-MM-yyyy', datafield: 'updated_on', width: '8%', cellclassname: '', },
                { text: 'Quotation Pdf', filterable: false, datafield: 'quotation_pdf', width: '6%', cellclassname: '',
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
                            defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
                        }
                        return (
                            defaultHtml
                        );
                    },
                    
                },
                { text: 'Expiry Date',filtertype: 'range', filtermode: 'range', cellsformat: 'dd-MM-yyyy', datafield: 'expired_at', width: '8%', cellclassname: '', },
                { text: 'Update By',filtertype: 'textbox', datafield: 'updated_by', width: '8%', cellclassname: '', },
            ];
        const nestedColumns = [
                { text: 'No of Packages', datafield: 'number_of_packages', width: '10%' },
                { text: 'Length (cm)', datafield: 'length', width: '8%' },
                { text: 'Width (cm)', datafield: 'width', width: '8%' },
                { text: 'Height (cm)', datafield: 'height', width: '8%' },
                { text: 'Gross Weight (kg)', datafield: 'gross_weight', width: '10%' },
                { text: 'Volumetric Weight(cm)', datafield: 'volumetric_weight', width: '14%' },
                { text: 'Chargeable Weight(kg)', datafield: 'chargeable_weight', width: '14%' },
                { text: 'Pricing', datafield: 'total_freight_cost', width: '8%' },
            ];

            const nestedGrids = {};
            const initrowdetails = (index, parentElement, gridElement, record) => {
                const nestedGridContainer = parentElement.children[0];
                //  console.log('Nested arrow clicked:', index, parentElement, gridElement, record);

                const parentRowId = record.uid.toString();
                nestedGrids[parentRowId] = nestedGridContainer;

                parentElement.addEventListener('click', (event) => {
                    const target = event.target;
                    // Check if the click target is the nested arrow
                    if (window.$(target).hasClass('jqx-icon-arrow-right')) {
                        // Handle nested arrow click here
                        // console.log('Nested arrow clicked:', record);
                        event.stopPropagation(); // Prevent event bubbling to the row details
                    }
                });
                // console.log(dataAdapter);
                const id = record.uid.toString();
                const uldGrid = Array.isArray(record.package_information)
                    ? record.package_information
                    : (record.package_information ? [record.package_information] : []);
 

                const nestedSource = {
                    datatype: 'array',
                    id: 'shipmentChildID',
                    datafields: [
                        { name: 'chargeable_weight', type: 'string' },
                        { name: 'gross_weight', type: 'string' },
                        { name: 'height', type: 'string' },
                        { name: 'length', type: 'string' },
                        { name: 'number_of_packages', type: 'string' },
                        { name: 'totalFreightCost', type: 'string' },
                        { name: 'volumetric_weight', type: 'string' },
                        { name: 'width', type: 'string' },
                        { name: 'total_freight_cost', type: 'string' },
                    ],
                    localdata: uldGrid,
                }

                const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);

                const nestedGridOptions = {
                    width: '70%',
                    pageable: false,
                    sortable: false,
                    // pageSize: 15,
                    autoheight: true,
                    height: (10 * 45),
                    selectionmode: 'none',
                    source: nestedDataAdapter,
                    filterable: false,
                    columns: nestedColumns,
                    rowdetails: true,
                    rowsheight: 45,
                    showemptyrow: false,
                    ready: function () {
                        // Manually set row IDs starting from 0
                        const rows = window.$(nestedGridContainer).jqxGrid('getrows');
                        for (let i = 0; i < rows.length; i++) {
                            const rowid = i; // Use index as the new row ID
                            const row = rows[i];
                            window.$(nestedGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
                            window.$(nestedGridContainer).jqxGrid('updaterow', rowid, row);
                            window.$(nestedGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
                        }
                    },
                };
                window.$(nestedGridContainer).jqxGrid(nestedGridOptions);
            };

            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                initrowdetails: initrowdetails,
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rowdetails: true,
                rowdetailstemplate: {
                    rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
                    rowdetailsheight: (5 * 45),
                    rowdetailshidden: true,
                },
                rendergridrows: function (params) {
                    return params.data;
                },
                rendered: function () {
                    const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                    (checkUlds).forEach(uldNumber => {
                        rows.forEach((element, index) => {
                            if (element.uld_number == uldNumber) {
                                window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                            }
                        });
                    });
                }
            };
            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRefs[activeTab].current).on('click', '.row_edit', function (event) {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
                loadDetails(rowData.id);
            });
            window.$(gridRefs[activeTab].current).on('click', '.quotation_modal', function (event) {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
                fetchQuotation(rowData.id);
                setQuotationModal(true)
            });
           window.$(gridRefs[activeTab].current).on('click', '.row_view', function (event) {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
                const export_shipment_record_id = rowData.export_shipment_record_id;
                const id = rowData.id;
               

                localStorage.setItem("AddShipmentType", "export");
                localStorage.setItem("ccbackUrl", "/ForwarderShipments/Quotation");
                localStorage.setItem("Ftab_shprec", "export");
                localStorage.setItem("SHEdit", export_shipment_record_id);
                localStorage.setItem("id", id);

                 history.push('/ForwarderShipments/AddShipmentRecords');
            });
            window.$(gridRefs[activeTab].current).on('click', '.row_update', function (event) {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
                // loadDetails('U', rowData.service_recovery_id);
                localStorage.setItem('RecoveryUpdate', JSON.stringify(rowData.service_recovery_id));
                 history.push('/UpdateRecovery');
            });
            window.$(gridRefs[activeTab].current).on('click', '.row_email', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
                const customer_id = rowData.customer_id;
                const id = rowData.id;
                setEmailId({ quotation_id : id, id: customer_id });
                setEmailData({email: rowData?.email});
                setShowModal(true)
                // fetchHandler(rowData.station)
            });
              window.$(gridRefs[activeTab].current).on('click', '.row_trash', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                // const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

                const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                const pageIndex = pagingInfo.pagenum;
                const pageSize = pagingInfo.pagesize;
                const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);

                setShowConfirm(true);
                setDeleteId(rowData.id);
            });
            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.id;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // console.log(checkUlds);
                    // if (!gridSelect.some(row => row.service_recovery_id === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.id !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });
            window.$(gridRefs[activeTab].current).off('cellclick');
            window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (event.args.columnindex > 2) {
                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                    }
                    // loadDetails('D', args.service_recovery_id);
                }
            });
        }
    }, [gridData]);

    // Customer grid setup
   

    const loadDetails = async (id) => {
        try {
            const res = await withRFSToken.post(`/quotation/details`, {id : id})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setFormData(innerData)
                    if (Array.isArray(innerData?.packages)) {
                        setSavedPackages(innerData.packages);
                        console.log("innerdata",innerData.packages);
                        const normalizedGroups = innerData.packages.map((pkg) => {
                            if (['length', 'width', 'height', 'number_of_packages', 'gross_weight'].includes(pkg)) {
                                    const metrics = calculatePackageMetrics(pkg);
                                     return {
                                        ...pkg,
                                        volumetric_weight: metrics.volumetric_weight,
                                        chargeable_weight: metrics.chargeable_weight,
                                        total_freight_cost: metrics.total_freight_cost,
                                    };
                                }
                        });
                    } else {
                        setSavedPackages([]);
                        setPackageGroups([{ number_of_packages: '', length: '', width: '', height: '', gross_weight: '', volumetric_weight: '', chargeable_weight: '', total_freight_cost: '' }]);
                    }
                    setActArcModal(true)
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleCloseModal = () => {
        setActArcModal(false);
        setFormData(initialFormData);
        // Reset form when discarding
        setPackageGroups([{ number_of_packages: '', length: '', width: '', height: '', gross_weight: '', volumetric_weight: '', chargeable_weight: '', total_freight_cost: '' }]);
        setSavedPackages([]);
        setEditIndex(null);
        setPackageShow(true);
    };

    // upload forward
    const fileInputRef = useRef(null);
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };
    const [actArcModal, setActArcModal] = useState(false);
    const handleDefineTask = () => {
        // Patch for AddExport.js to receive VWA-only add intent
        localStorage.setItem('AddExportInitQuotation', JSON.stringify({ quotation: {customer_type : 'C', shipment_type : 'E',origin: 'AMS', destination: '' , add_or_edit: 'add'}, savedPackages: [] }));
        // setFormData({customer_type : 'C', shipment_type : 'E',origin: 'AMS', destination: '' , add_or_edit: 'add'  }) // remove/set inactive
        // setActArcModal(true);
        localStorage.removeItem('addexport');
        setRows([{ ...defaultRow }]);
        localStorage.setItem("AddShipmentType", "export");
        localStorage.setItem("ccbackUrl", "/ForwarderShipments/Quotation");
        localStorage.setItem("Ftab_shprec", "export");
        history.push("/ForwarderShipments/AddShipmentRecords");
        // Reset form when opening modal
        setPackageGroups([{ number_of_packages: '', length: '', width: '', height: '', gross_weight: '', volumetric_weight: '', chargeable_weight: '', total_freight_cost: '' }]);
        setSavedPackages([]);
        setEditIndex(null);
        setPackageShow(true);
    }

    const resetFilters = () => {
        window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
        // gridSelect.forEach(item => {
        //     const selectedRowBoundIndex = item.boundindex;
        //     window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
        // });
        // setGridSelect([]);
    };

    


    const defineTask = async () => {
        // Basic validation
        if (!formData?.origin || !formData?.destination || !formData?.customer_id) {
            toast.error('Origin, Destination and Customer are required.');
            return;
        }
        if (!savedPackages || savedPackages.length === 0) {
            toast.error('Please add at least one package before saving!');
            return;
        }

        const payload = {
            origin: formData?.origin ||  '',
            destination: formData?.destination || '',
            customer_id: formData?.customer_id?.value || formData?.customer_id || '',
            customer_type : formData?.customer_type , 
            shipment_type : formData?.shipment_type,
            incoterm: formData?.incoterm,
            packages: savedPackages,
            ...(formData?.id ? { id: formData.id } : {})
        };

        console.log("payload " ,payload);

        try {
            const res = await withRFSToken.post('quotation/add-update', payload);
            if (res.data.response_code == 200) {
                const id = res.data.response_data?.id ;
                const export_shipment_record_id = res.data.response_data?.export_shipment_record_id;
                setActArcModal(false);
                if (gridRefs[activeTab]?.current) {
                    window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                }
                toast.success(res.data.response_msg);
                setPackageGroups([{ number_of_packages: '', length: '', width: '', height: '', gross_weight: '', volumetric_weight: '', chargeable_weight: '', total_freight_cost: '' }]);
                setSavedPackages([]);
                setEditIndex(null);
                if(formData?.add_or_edit == 'add'){
                localStorage.setItem("AddShipmentType", "export");
                localStorage.setItem("ccbackUrl", "/ForwarderShipments/Quotation");
                localStorage.setItem("Ftab_shprec", "export");
                localStorage.setItem("SHEdit", export_shipment_record_id);
                localStorage.setItem("id", id);
                history.push('/ForwarderShipments/AddShipmentRecords');
            }
                setPackageShow(true);
            } else {
                toast.error(res.data.response_msg || 'Failed to save quotation');
            }
        } catch (error) {
            console.error('Error sending request:', error);
            toast.error('Failed to save quotation. Please try again.');
        }
    };

    const [rows, setRows] = useState([{ ...defaultRow }]);


    const handleRowChange = (name, value) => {
          if (name == 'customer_type') {
            // setGetCustomer([]);
            // console.log("hehe i am here 1");
            fetchCustomer(value);
            // console.log("hehe i am here 2");
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
                customer_id: '',   
            }));
        } else if(name == 'shipment_type'){
            if(value == 'E'){
                setFormData((prevFormData) => ({
                ...prevFormData, [name]: value, origin: 'AMS', destination: '',   
            }));
            } else if (value == 'I'){
                setFormData((prevFormData) => ({
                ...prevFormData, [name]: value, origin : '', destination: 'AMS',   
            }));
            } 

        }
        else {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
            }));
        }
    };

    //delete 

    const [showConfirm, setShowConfirm] = useState(false);
    
    const closeConfirm = () => {
        setShowConfirm(false);
    }
    const handleConfirmation = async (cnf) => {
        if (cnf) {
            try {
                const res = await withRFSToken.post(`quotation/delete-restore`, { id: deleteId })
                    .then(function (res) {
                        const innerData = res.data.response_data;
                        toast.success(res.data.response_msg);
                        setShowConfirm(false);
                        setTimeout(() => {
                            setIsLoading(false);
                            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata')
                        }, 1);
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else {
            setShowConfirm(false);
        }

    }

    const handleStatusChange = async (status) => {
        if(gridSelect.length != 1){
            toast.error("Only one data, status can be changes");
            return;
        }
        try {
            const res = await withRFSToken.post(`quotation/quotation-status-update`, { id: gridSelect[0].id , status : status })
                    .then(function (res) {
                        // const innerData = res.data.response_data;
                        // toast.success(res.data.response_msg);
                        // setShowConfirm(false);
                        if(res.data.response_code == 200)
                            toast.success(res.data.response_msg)
                            setTimeout(() => {
                                setIsLoading(false);
                                window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata')
                            }, 1);
                            gridSelect.forEach(item => {
                                const selectedRowBoundIndex = item.boundindex;
                                window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                                });
                        
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
            }

    }
    
    const handleModalClose = () =>{
        setShowModal(false);
        setEmailData({ email: '' });
    }

    const handleCloseQuotation = () => {
        setQuotationModal(false);
    }

    const handleEmailChange = (e) => {
    const { name, value } = e.target;
    setEmailData(prevData => ({
        ...prevData,
        [name]: value
    }));
};

    const handleSaveEmail = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const email = emailData?.email?.trim();
    
    if (!email || !emailRegex.test(email)) {
        toast.error('Please enter a valid email address');
        return;
    }
    try {
        setDisLoading(true);
        const res = await withRFSToken.post(`address-book/add-update`, { ...emailId , email:emailData?.email })
            .then(function (res) {
                const innerData = res.data.response_data;
                toast.success(res.data.response_msg);
                setDisLoading(false);
                setShowModal(false);
                setTimeout(() => {
                    setIsLoading(false);
                    window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata')
                }, 1);
            });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    // Customer-related functions
    const contactModalOpen = () => {
        setIsLoadingc(false);
        setCgridData({ Active: {} });
        setContactModal(true)
    }

    const handleAddCustomer = () => {
        setCustomerModal(true);
    }

    const hideCustomerModal = () => {
        setCustomerModal(false);
        setCustomerData({});
    }

    const handleCustomerChange = (name, value) => {
        setCustomerData(prevData => ({
            ...prevData,
            [name]: value
        }));
    }

    const handleCustomerSave = async () => {
        try {
            const res = await withRFSToken.post('address-book/add-update', customerData)
                .then(function (res) {
                    const innerData = res.data.response_data;
                    if (res.data.response_code != 200) {
                        toast.error(res.data.response_msg)
                        return;
                    }
                    toast.success(res.data.response_msg);
                    hideCustomerModal();
                    window.$(cgridRef.current).jqxGrid('updatebounddata');
                });
        } catch (error) {
            console.error('Error saving customer:', error);
            toast.error('Failed to save customer');
        }
    }

    const handleCustomerApply = () => {
        if (customerGridSelect.length == 0) {
            toast.error('Please select at least one customer')
        } else if (customerGridSelect.length == 1) {
            setContactModal(false);
            setFormData(prevData => ({
                ...prevData,
                customer_id: customerGridSelect[0].id,
                name: customerGridSelect[0].name + ' - ' + customerGridSelect[0].customer_type,
                customer_address: customerGridSelect[0].address || ''
            }));
            setCustomerGridSelect([]);
        } else {
            toast.error('You can select one customer at a time')
        }
    }
    
     const handleMoveToActArc = (info) => {
            if (gridSelect.length <= 0) {
                toast.error('Please select Quotation first');
            } else {
                setShowConfirmation(true);
                setConfirmationInfo(info)
                // setModalAction(() => confirmMoveToActArc); // Set the action to be performed on confirmation
            }
        };

    const confirmMoveToActArc = async () => {
            // console.log('101', gridSelect);
            const sendAction = activeTab == 'Active' ? 'I' : 'A';
            const ids = gridSelect?.map(data => data.id)
            try {
                const res = await withRFSToken.post('quotation/update-activity-status', { id: ids })
                    .then(function (res) {
                        if (res.data.response_code == 200) {
                            gridSelect.forEach(item => {
                                const selectedRowBoundIndex = item.boundindex;
                                window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                            });
                            setGridSelect([]);
                            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                            setShowConfirmation(false);
                        }
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }

        const handleSelect = (row) => {
        console.log('savedRows', row);
        setCustomerGridSelect(row)
        }

    return (
        <>
        {console.log("gridSelect",gridSelect)}
          {disLoading &&
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
            }
            <div className="">
                <Header page_type='fsm' logo_url='/ForwarderShipments/ShipmentRecords' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <div className="mainTab">
                            <TopMenu module='FSHPMNGR' />
                            <div className="lcontent">
                                <div className="nestedtabs rounded minh">
                                    <div className='d-flex'>
                                        <button className="addtruck me-2" variant="primary" onClick={handleDefineTask}>
                                            <span> <FontAwesomeIcon icon={faPlus} /> Add</span>
                                        </button>
                                        {/* <div className='ulddown'>
                                         <button> <img title='' src={trash} /> Trash </button>
                                        </div> */}
                                         <Dropdown>
                                            <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                                                <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                            </Dropdown.Toggle>
                            
                                            <Dropdown.Menu>
                                                {/* <Dropdown.Item onClick={() => handleStatusChange("revised")}>Revised</Dropdown.Item>  */}
                                                <Dropdown.Item onClick={() => handleStatusChange("processing")}>Processing</Dropdown.Item> 
                                                <Dropdown.Item onClick={() => handleStatusChange("quoted")}>Quoted</Dropdown.Item> 
                                                <Dropdown.Item onClick={() => handleStatusChange("accepted")}>Accepted</Dropdown.Item>
                                                <Dropdown.Item onClick={() => handleStatusChange("rejected")}>Rejected</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>

                                         <div className='ulddown'>
                                            <button onClick={() => handleMoveToActArc(activeTab === 'Active' ? 'R' : 'A')}>
                                                <img title='' src={activeTab === 'Active' ? Arcv : Activ} /> {activeTab === 'Active' ? 'Archive' : 'Active'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="maindiv">
                                    <div className='trashdonload'>
                                    <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                                        <Tab eventKey="Active" title={<span>Active</span>} className='moveto'>
                                        {/* <Loader isLoading={isLoading} /> */}
                                        {!isLoading && <>
                                            {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                            <div ref={gridRefs.Active} className='bookinggrid' ></div>
                                        </>
                                        }
                                        {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
                                        </Tab>
                                        <Tab eventKey="Archived" title={<span>Archive</span>} className='moveto'>
                                        {/* <Loader isLoading={isLoading} /> */}
                                        {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                        {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
                                        {/* <div ref={gridRefs.Archived} className='bookinggrid' ></div> */}
                                        </Tab>
                                    </Tabs>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

           
            <Modal show={actArcModal} onHide={() => handleCloseModal()} className='addfrom change_type add_quotation' centered size="xl">
                <Modal.Header closeButton >
                    {/* <Modal.Title>Add Quotation</Modal.Title> */}
                </Modal.Header>
                <Modal.Body>
                    <>
                        <h3>Add Quotation</h3>
                        <Row className='mt-2'>
                        <Col sm="12">
                            <div className='missing_info modal_from'>
                                    <h4>Shipment Information</h4>
                                    <p></p>
                                    <Form.Group as={Row} className="mb-0 align-items-center" controlId="exampleForm.ControlInput1">
                                        <Col sm='6'>
                                            {formData?.customer_type  == 'C' && (
                                                <>
                                                <Form.Label className='mb-3'>
                                                    {formData?.customer_type  == 'A' ? 'Agent Name' : 'Customer Name'}
                                                    <span></span>
                                                </Form.Label>
                                                <span className='d-flex'>
                                                    <Form.Control type="text" name="customer" className='flex-shrink-1' value={formData.name} disabled />
                                                    <Button className='flex-grow-1 ms-2 me-2 customer_icon' onClick={contactModalOpen}><FontAwesomeIcon icon={faUser} /></Button>
                                                </span>
                                            </>)}
                                        </Col>
                                        <Col sm='6'>
                                            <Form.Label className='mb-2'>Origin <span className='danger'>*</span></Form.Label>
                                            <Select
                                                options={getDestination}
                                                onChange={(selected) => { handleRowChange('origin', selected?.value || ''); }}
                                                placeholder="Origin"
                                                className=''
                                                value={getDestination?.find(option => option.value === formData?.origin)}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                                isDisabled={formData?.shipment_type == 'E'}
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-0 align-items-center" controlId="exampleForm.ControlInput1">
                                        <Col sm='6'>
                                            <Form.Check
                                                type="radio" label="Agent" id="customer_type-1" name="customer_type" value="A" checked={formData?.customer_type == "A"}
                                                onChange={(e) => handleRowChange('customer_type', 'A')}
                                            />
                                            <Form.Check
                                                type="radio" label="Customer" id="customer_type-2" name="customer_type" value="C" checked={formData?.customer_type == "C"}
                                                onChange={(e) => handleRowChange('customer_type', 'C')}
                                            />
                                        </Col>
                                        <Col sm='6'>
                                            <Form.Label className='mb-2'>Destination <span className='danger'>*</span></Form.Label>
                                            <Select 
                                                options={getDestination}
                                                onChange={(selected) => { handleRowChange('destination', selected?.value || ''); }}
                                                placeholder="Destination"
                                                className=''
                                                value={getDestination?.find(option => option.value === formData?.destination)}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                                isDisabled={formData?.shipment_type == 'I'}
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-0 align-items-start" controlId="exampleForm.ControlInput1">
                                        <Col sm='6'>
                                            <Form.Check
                                                type="radio" label="Export" id="shipment_type-1" name="shipment_type" value="E"
                                                checked={formData?.shipment_type === "E"} onChange={() => handleRowChange('shipment_type', 'E')}
                                            />
                                            <Form.Check
                                                type="radio" label="Import" id="shipment_type-2" name="shipment_type" value="I"
                                                checked={formData?.shipment_type === "I"} onChange={() => handleRowChange('shipment_type', 'I')}
                                            />
                                        </Col>

                                        <Col sm='6'>
                                            <Form.Label className='mb-2'>Incoterm<span></span></Form.Label>
                                            <Select
                                                options={incotermOption}
                                                onChange={(selected) => { handleRowChange('incoterm', selected.value); }}
                                                placeholder="Incoterm" className=''
                                                value={incotermOption?.find(option => option.value === formData?.incoterm)}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </Col>
                                    </Form.Group>
                            </div>
                        </Col>
                        <Col sm='6'>
                            <div className='missing_info modal_from'>
                                <h4>Packing Information</h4>
                                <p></p>
                                 {!packageShow &&
                                    <div className='expt_add_hwb mt-5'>
                                    <Button onClick={() => setPackageShow(true)}>Add Packages's</Button>
                                    </div>
                                }
                                {packageShow &&
                                    <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                                        

                                        <Col sm='12'>
                                        <div className='d-flex justify-content-between align-items-center mb-2'>
                                        </div>
                                        <Accordion defaultActiveKey="0" flush>
                                            {packageGroups.map((group, idx) => (
                                            <Accordion.Item eventKey={idx.toString()} key={idx}>
                                                <Accordion.Body>
                                                <Form.Group as={Row} className="mb-2">
                                                <Col sm='6'>
                                                <Form.Label>Number of packages<span className='danger'>*</span></Form.Label>
                                                <Form.Control type="text" name='number_of_packages' value={group.number_of_packages || ''}
                                                // maxLength='5' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
                                                onChange={e => handleGroupChange(idx, 'number_of_packages', e.target.value)}
                                                />
                                                </Col>
                                                <Col sm='6'>
                                                  <Form.Label>Gross Weight (kg)<span></span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={group.gross_weight}
                                                        onChange={e => handleGroupChange(idx, 'gross_weight', e.target.value)}
                                                    />
                                                </Col>
                                                 </Form.Group>
                                                <Form.Group as={Row} className="mb-2">
                                                    <Col sm='4'>
                                                    <Form.Label>Length (cm)<span className='danger'>*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={group.length}
                                                        onChange={e => handleGroupChange(idx, 'length', e.target.value)}
                                                    />
                                                    </Col>
                                                    <Col sm='4'>
                                                    <Form.Label>Width (cm)<span></span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={group.width}
                                                        onChange={e => handleGroupChange(idx, 'width', e.target.value)}
                                                    />
                                                    </Col>
                                                     <Col sm='4'>
                                                    <Form.Label>Height (cm)<span className='danger'>*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={group.height}
                                                        onChange={e => handleGroupChange(idx, 'height', e.target.value)}
                                                    /> </Col>
                                                </Form.Group>
                                                  <Form.Group as={Row} className="mb-2">
                                                    <Col sm='6'>
                                                    <Form.Label>Volumetric Weight (kg)</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={group.volumetric_weight}
                                                        onChange={e => handleGroupChange(idx, 'volumetric_weight', e.target.value)}
                                                        disabled
                                                    />
                                                    </Col>
                                                    <Col sm='6'>
                                                    <Form.Label>Chargeable Weight (kg)<span></span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={group.chargeable_weight}
                                                        onChange={e => handleGroupChange(idx, 'chargeable_weight', e.target.value)}
                                                        disabled
                                                    />
                                                    </Col>
                                                </Form.Group>
                                                  
                                                
                                                {packageGroups.length > 1 && (
                                                    <Button
                                                        variant="outline-primary"
                                                        className="w-100"
                                                        onClick={() => handleDeleteGroup(idx)}
                                                    >
                                                        Delete Group
                                                    </Button>
                                                )}
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            ))}
                                        </Accordion>
                                        <Button
                                            variant="primary"
                                            className="w-100 mt-2"
                                            onClick={handleSaveHawb}
                                        >   
                                            {editIndex !== null ? 'Update' : 'Save'}
                                        </Button>
                                        </Col>
                                    </Form.Group>
                                    }
                                </div>
                        </Col>

                        <Col sm='6'>
                                <div className='missing_info modal_from'>
                            <h4>Packing Details</h4>
                            <p></p>
                            <div className='d-flex justify-content-between chargable'>
                                <span>Total Vol Weight : {totals.totalVolumetricWeight}</span> 
                                <span>Total Charge Weight : {totals.totalChargeableWeight}</span>
                            </div>
                             
                            <div className='expcet_hawb'>
                                {savedPackages.map((item, idx) => (
                                <div key={idx} className='hawb_box'>
                                    <div className='d-flex justify-content-between align-items-center'>
                                    <div> <h3>Number of packages: {item.number_of_packages}</h3> </div>
                                    <div>
                                        <Button variant="link" onClick={() => handleEditHawb(idx)}> <img src={edit} /></Button>
                                        <Button variant="link" onClick={() => handleDeleteHawb(idx)}> <img src={Trash} /></Button>
                                    </div>
                                    </div>
                                    <div>
                                        <div>
                                            <span>Gross Weight: {item.gross_weight}</span> <span> Width (cm): {item.width}</span> <span> Height (cm): {item.height}</span>
                                        </div>
                                        <div>
                                            <span>Volumetric Weight (kg): {item.volumetric_weight} </span><span> Chargeable Weight (kg): {item.chargeable_weight}</span>
                                        </div>
                                    </div>
                                </div>
                                ))}
                                
                            </div>
                            </div>
                        </Col>
                            
                        </Row>

                    </>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom justify-content-center'>
                        <Button variant="secondary" onClick={() => handleCloseModal()}>
                            Discard
                        </Button>
                        <Button variant="primary" onClick={() => defineTask()}>
                            Save
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal >

            <Modal className='raintrac' show={showConfirm} onHide={() => closeConfirm(false)} centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h2>Confirm Delete</h2>
                    <p>If you proceed with the change, all data in this section will be removed.
                        Are you sure you want to continue?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => handleConfirmation(false)}>
                        No
                    </Button>
                    <Button variant="primary" onClick={() => handleConfirmation(true)}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showModal} onHide={handleModalClose} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                    <Modal.Title>Send Email</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                        <Form.Control name='email' placeholder='Add Email Address' onChange={handleEmailChange} value={emailData?.email} disabled={!!emailData?.email}/>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={handleModalClose}> Cancel </Button>
                        <Button variant="primary" onClick={handleSaveEmail}> Send Email </Button>
                    </div>
                </Modal.Footer>
            </Modal>

            {/* Contact Finder Modal */}
            <Modal show={contactModal} onHide={() => setContactModal(false)} className='addfrom add_category_modal' centered size='xl'>
                <Modal.Header closeButton>
                    <Modal.Title>Contact Finder</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/*<span className='text-end mt-2 fwr_customer_add'><Button variant="primary" onClick={handleAddCustomer} >+ Add Customer</Button></span> */}
                    {/* <div className='trashdonload add_category_modal_bdy_content mt-0'>
                        {!isLoadingc && <div ref={cgridRef} className='bookinggrid' ></div>}
                    </div> */}
                     <Customer
                        isModal={true}
                        onSelect={handleSelect}
                        showAddCustomer={false}
                     />
                </Modal.Body>
                <Modal.Footer className='justify-content-center'>
                    <div className="d-flex w-50 mx-auto are_bottom justify-content-center">
                        <Button variant="secondary" onClick={() => setContactModal(false)}>Cancel</Button>
                        <Button type="button" className="btn btn-primary" onClick={handleCustomerApply}>Apply</Button>
                    </div>
                </Modal.Footer>
            </Modal>

            {/* Add Customer Modal */}
            <Modal show={customerModal} centered onHide={hideCustomerModal} className='addfrom' >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Add Customer
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group as={Row} className='mb-2'>
                        <Col sm="12">
                            <Form.Label>Customer Name <span>*</span></Form.Label>
                            <Form.Control type="text" name='name' placeholder="Add Name" value={customerData.name} onChange={(e) => handleCustomerChange('name', e.target.value)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className='mb-2'>
                        <Col sm="12">
                            <Form.Label>Customer Type <span>*</span></Form.Label>
                            <Select
                                options={CustomerOptions}
                                onChange={(selected) => {
                                    handleCustomerChange('customer_type', selected ? selected.value : '');
                                }}
                                placeholder="Customer"
                                className='rfs_autoslct'
                                name="customer_type"
                                value={CustomerOptions.find(option => option.value === customerData.customer_type) || null}
                            />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className='mb-2'>
                        <Col sm="12">
                            <Form.Label>Agent Code</Form.Label>
                            <Form.Control type="text" name='agent_code' placeholder="Add Agent Code" value={customerData.agent_code} onChange={(e) => handleCustomerChange('agent_code', e.target.value)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className='mb-2'>
                        <Col sm="12">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="text" name='email' placeholder="Add Email" value={customerData.email} onChange={(e) => handleCustomerChange('email', e.target.value)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className='mb-2'>
                        <Col sm="12">
                            <Form.Label>Account Number</Form.Label>
                            <Form.Control type="text" name='account_number' placeholder="Add Account no." value={customerData.account_number} onChange={(e) => handleCustomerChange('account_number', e.target.value)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className='mb-2'>
                        <Col sm="12">
                            <Form.Label>Address</Form.Label>
                            <Form.Control type="text" name='address' placeholder="Add Address" value={customerData.address} onChange={(e) => handleCustomerChange('address', e.target.value)} />
                        </Col>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={hideCustomerModal}>
                            Discard
                        </Button>
                        <Button variant="primary" onClick={handleCustomerSave}>
                            Save
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

             <Modal className='raintrac' show={showConfirmation} onHide={() => setShowConfirmation(false)}>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h2>{confirmationInfo == 'D' ? 'Confirm Delete' : `Selected ${gridSelect.length > 1 ? "Shipment's" : 'Shipment'} will move to ${activeTab == 'Active' ? 'Archive' : 'Active'}`}</h2>
                    <p>If you proceed with the change, user data will be {confirmationInfo == 'D' ? 'removed' : `moved to ${activeTab == 'Active' ? 'Archive' : 'Active'}`}.
                        Are you sure you want to continue?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowConfirmation(false)}>
                        No
                    </Button>
                    <Button variant="primary" onClick={confirmMoveToActArc}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    )
}

export default Quotation;
